// import "owl.carousel";
// import lightbox from "lightbox2/dist/js/lightbox";
import Flickity from "flickity";
import "flickity-fullscreen";
import "flickity-imagesloaded";

const $ = window.jQuery;
const $window = window.$window || $(window);

const FlickityCarousel = {
  init() {
    var $galleries = $("main .wp-block-gallery");
    if (!$galleries.length) return;

    $galleries.each((index, element) => {
      // remove links from images
      $(element).find("figure").find("a").contents().unwrap();
      // wrap gallery in a carousel
      $(element).wrap('<div class="carousel"/>').contents().unwrap();
    });

    var $carousels = $(".carousel");
    $carousels.each((index, element) => {
      new Flickity(element, {
        imagesLoaded: true,
        fullscreen: true,
        // // options
        cellAlign: "left",
        // // contain: true,
        setGallerySize: false,
        cellSelector: "figure",
        // lazyLoad: true,
        wrapAround: true,
      });
    });
  },
};

export default FlickityCarousel;
